<!-- TEMPLATE -->
<template>
  <dean-dialog
          class="graph"
          title="Gewonnen en verloren offertes"
          :icon="invoiceDetailsIcon"
          align-top>
    <div class="row" v-if="!nodata">
      <div class="column left">
        <span class="data">Gewonnen {{ data.won }}</span>
        <span class="percentage">{{ percentage.won }} %</span>
      </div>
      <div class="column middle">
        <pie-chart :library="options" :legend="false" :data="data" height="130px" :donut="true"
                   :colors="['#00839b', '#dd1b16']"></pie-chart>
        <div>
          <svg height="140px" width="27px" :style="{transform: 'rotate(' + pointerRotation + 'deg)'}">
            <use xlink:href="#arrow-pointer"></use>
          </svg>
        </div>
      </div>
      <div class="column right">
        <span class="data">Verloren {{ data.lost }}</span>
        <span class="percentage">{{ percentage.lost }} %</span>
      </div>
    </div>
    <div class="row nodata" v-else style="display: inline-block;">
      <dean-icon width="100px" :glyph="archiveIcon"></dean-icon>
      <div class="text">no data</div>
    </div>
    <transition name="fade" mode="out-in" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </dean-dialog>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';

  // DEAN COMPONENTS
  import {
    deanIcon,
    invoiceDetailsIcon,
    groupIcon,
    deanDialog,
    deanButton,
    archiveIcon,
  } from '@deanone/dean-components';
  import Chartkick from 'vue-chartkick';
  import Chart from 'chart.js';
  import axios from 'axios';
  import pointer from '@/assets/arrow-pointer.svg';
  import DeanLoadOverlay from '@deanone/dean-components/src/components/deanLoadOverlay.vue';

  Vue.use(Chartkick.use(Chart));

  @Component({
    components: {
      DeanLoadOverlay,
      deanIcon,
      Chartkick,
      Chart,
      invoiceDetailsIcon,
      groupIcon,
      deanDialog,
      deanButton,
      archiveIcon,
      pointer,
    },
  })

  export default class WinLostGraph extends Vue {
    public invoiceDetailsIcon: object = invoiceDetailsIcon;
    public groupIcon: object = groupIcon;
    public isLoading: boolean = true;
    public archiveIcon: object = archiveIcon;
    public options: object = {
      circumference: Math.PI,
      rotation: Math.PI,
      elements: {
        arc: {
          borderWidth: 0,
        },
      },
    };
    public data: { won: number, lost: number } = {
      won: 0,
      lost: 0,
    };
    public percentage: { won: number, lost: number } = {
      won: 0,
      lost: 0,
    };
    public pointerRotation: number = 90;
    public nodata: boolean = true;

    public header: string = '';
    public subHeader: string = '';

    public mounted() {
      axios
        .post('/-/trade/api/widgets.quotesWonLost')
        .then((response) => {
          Vue.set(this.data, 'won', response.data.amountWon);
          Vue.set(this.data, 'lost', response.data.amountLost);
          if (response.data.amountWon + response.data.amountWon === 0) {
            Vue.set(this.percentage, 'lost', 50);
            Vue.set(this.percentage, 'won', 50);
          } else {
            this.nodata = false;
            Vue.set(this.percentage, 'lost', Math.round((this.data.lost * 100) / (this.data.won + this.data.lost)));
            Vue.set(this.percentage, 'won', Math.round((this.data.won * 100) / (this.data.won + this.data.lost)));
          }
          let pointerDeg = Math.ceil((this.percentage.won / 100) * 180 - 90);
          if (Math.sign(pointerDeg) === 1) {
            pointerDeg -= 2;
          } else if (Math.sign(pointerDeg) === -1) {
            pointerDeg += 1;
          }
          Vue.set(this, 'pointerRotation', pointerDeg);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss">
</style>
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dialog :deep {
    padding: 0;
  }

  .dialog :deep(.dean-dialog-container) {
    width: 100%;
    height: 100%;
  }

  .dialog :deep(.dean-dialog-container .dean-dialog-content) {
    height: 100%;

    .dean-dialog-slot {
      overflow-y: inherit;
    }
  }

  .column {
    margin-top: auto;
  }

  .row .nodata {
    color: var(--color-light-shade-1, $color-light-shade-1);
    fill: var(--color-light-shade-1, $color-light-shade-1);
  }

  .column span {
    display: flex;
    justify-content: center;
  }

  .left, .right {
    font-size: 18px;
    color: #000;
    width: 15%;
  }

  .left .data {
    color: #00839B;
  }

  .right .data {
    color: #DD1B16;
  }

  .percentage {
    font-weight: bold;
  }

  .middle {
    width: 70%;
    height: 120px;
  }

  .column svg {
    transform-origin: bottom;
    position: relative;
    right: 0px;
    bottom: 135px;
  }
</style>
